import { RTable } from "../../Component/Table/RTable";
import { TableStructure } from "../../Component/Table/TableStructureInterface";
import { formInterface } from "../../Component/GenericForm/formInterface";
import { PageHeader, SectionHeader } from "../../Component/Common/Headers";
import { dateFormat } from "../../Helpers/commonFunction/commonFunction";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../../Helpers/config/config";

export const UserList = () => {
  const tableStructure: TableStructure[] = [
    {
      name: "id", render: (data: any, index: any) => {
        return index;
      },
    },
    {
      name: "Name", render: (data: any, index: any) => {
        return `${data.name}`;
      },
    },
    { name: "Email", key: "email" },
    { name: "Role", key: "role" },
    {
      name: "CreatedAt", render: (data: any, index: any) => {
        return dateFormat(data.createdAt);
      }
    },

    {
      name: "Action", render: (data: any, onDelete: any) => {
        return <><Link to={`/UserForm/${data.id}`}>
          <img width="16px" src={PUBLIC_URL + "/images/edit.svg"} alt="edit" />
        </Link>
          <Link to="#" onClick={() => { onDelete(data.id) }}>
            <img width="16px" src={PUBLIC_URL + "/images/delete.svg"} alt="delete" />
          </Link></>;
      },
    },
  ];

  const SearchInter: formInterface[] = [
    { name: "Name", type: 'text', key: 'name', condition: 'selector', md: 12 },
  ]

  return (
    <div className="container">
      <PageHeader
        title="User Management"
        subtitle="Configure system users"
      />
      <RTable xFileName="user_data" Addlink="/UserForm" deleteUrl="users" api="users/withPagination" tableStructure={tableStructure} />
    </div>
  );
};
